import React, { useEffect, useState } from "react";

export const fitImageSize = (width, height, availableWidth, availableHeight, zoom = 1) => {
  if (!width || !height || !availableWidth || !availableHeight) return null;
  const scale = Math.min(1, availableWidth / width, availableHeight / height) * zoom;
  return { width: width * scale, height: height * scale };
};

export const FittedImage = ({ src, alt, zoom }) => {
  const [container, setContainer] = useState(null);
  const [bounds, setBounds] = useState(null);
  const [natural, setNatural] = useState(null);
  useEffect(() => {
    if (!container) return undefined;
    const measure = () => setBounds({ width: container.clientWidth, height: container.clientHeight });
    measure();
    const observer = typeof ResizeObserver === "undefined" ? null : new ResizeObserver(measure);
    observer?.observe(container);
    window.addEventListener("resize", measure);
    return () => { observer?.disconnect(); window.removeEventListener("resize", measure); };
  }, [container]);
  const size = natural?.src === src && bounds && fitImageSize(natural.width, natural.height, bounds.width, bounds.height, zoom);
  return <div className="forum-fitted-image" ref={setContainer}>
    <img src={src} alt={alt} onLoad={(event) => setNatural({ src, width: event.currentTarget.naturalWidth, height: event.currentTarget.naturalHeight })}
      style={size ? { width: `${size.width}px`, height: `${size.height}px` } : { maxWidth: "100%", maxHeight: "100%" }} />
  </div>;
};
